import {
  getUserRoles,
  userSetPassword,
  userResetPassword,
  userRegister,
  userLogin,
  userValidate,
  userUpdate,
  userLogout,
} from '@/api'
import router from '@/router'
import { dispatch } from 'helpers/eventbus'
import {nextTick} from 'vue'

export default {
  /**
   * @return {{userRoles: null, userSetPassword: boolean, userSetPasswordError: boolean, userResetPassword: boolean, userResetPasswordError: boolean, userRegistered: boolean, userRegisterError: string, user: null|import('@/types').User, userLoginError: string, userUpdated: boolean, currentLanguage: string}}
   */
  state: () => ({
    userRoles: null,
    userSetPassword: false,
    userSetPasswordError: false,
    userResetPassword: false,
    userResetPasswordError: false,
    userRegistered: false,
    userRegisterError: '',
    user: null,
    userLoginError: '',
    userUpdated: false,
    currentLanguage: 'de',
  }),
  actions: {
    async getUserRoles({ commit }) {
      try {
        const response = await getUserRoles()
        commit('setUserRoles', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async userSetPassword({ commit }, payload) {
      try {
        await userSetPassword(payload)
        commit('setUserSetPassword', true)
      } catch (error) {
        commit('setUserSetPasswordError', error.response.data.message)
        console.error(error)
      }
    },
    async userResetPassword({ commit }, payload) {
      try {
        await userResetPassword(payload)
        commit('setUserResetPassword', true)
      } catch (error) {
        commit('setUserResetPasswordError', error.response.data.message)
        console.error(error)
      }
    },
    async userRegister({ commit }, payload) {
      try {
        await userRegister(payload)
        commit('setUserRegistered', true)
      } catch (error) {
        commit('setUserRegisterError', error.response.data.message)
        console.error(error)
      }
    },
    async userLogin({ commit }, payload) {
      try {
        const response = await userLogin(payload)
        const { data:user } = response
        commit('setUser', user)

        // We need to wait for the user to be set before we can dispatch the user::login event
        await nextTick()
        dispatch('user::login', { user })

      } catch (error) {
        commit('setUserLoginError', error.response.data?.message)
        console.error(error)
      }
    },
    async userValidate({ commit }, payload) {
      try {
        await userValidate(payload)
      } catch (error) {
        console.error(error)
        commit('setUser', null)
        router.push({ path: '/' })
      }
    },
    async userUpdate({ commit }, payload) {
      try {
        await userUpdate(payload)
        commit('setUserUpdated', true)
      } catch (error) {
        console.error(error)
      }
    },
    async userLogout({ commit }) {
      try {
        await userLogout()
        commit('setUser', null)
        router.push({ path: '/' })
      } catch (error) {
        console.error(error)
      }
    },
  },
  mutations: {
    setUserRoles(state, payload) {
      state.userRoles = payload
    },
    setUserSetPassword(state, payload) {
      state.userSetPassword = payload
    },
    setUserSetPasswordError(state, payload) {
      state.userSetPasswordError = payload
    },
    setUserResetPassword(state, payload) {
      state.userResetPassword = payload
    },
    setUserResetPasswordError(state, payload) {
      state.userResetPasswordError = payload
    },
    setUserRegistered(state, payload) {
      state.userRegistered = payload
    },
    setUserRegisterError(state, payload) {
      state.userRegisterError = payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setUserLoginError(state, payload) {
      state.userLoginError = payload
    },
    setUserUpdated(state, payload) {
      state.userUpdated = payload
    },
    setCurrentLanguage(state, payload) {
      state.currentLanguage = payload
    },
  },
  getters: {
    userRoles(state) {
      return state.userRoles
    },
    userSetPassword(state) {
      return state.userSetPassword
    },
    userSetPasswordError(state) {
      return state.userSetPasswordError
    },
    userResetPassword(state) {
      return state.userResetPassword
    },
    userResetPasswordError(state) {
      return state.userResetPasswordError
    },
    userRegistered(state) {
      return state.userRegistered
    },
    userRegisterError(state) {
      return state.userRegisterError
    },
    /**
     * @param state
     * @return {null | import('@/types').User}
     */
    user(state) {
      return state.user
    },
    userLoginError(state) {
      return state.userLoginError
    },
    userUpdated(state) {
      return state.userUpdated
    },
    currentLanguage(state) {
      return state.currentLanguage
    },
  },
}
